import { render, staticRenderFns } from "./InsurerAutoItems.vue?vue&type=template&id=298e65e2"
import script from "./InsurerAutoItems.vue?vue&type=script&lang=js"
export * from "./InsurerAutoItems.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports